"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultDateConfig = void 0;
var get_ordinal_string_for_number_1 = require("../../i18n/functions/date/utils/get-ordinal-string-for-number");
/**
 * The default date configuration.
 */
exports.defaultDateConfig = {
    formats: {
        iso: 'YYYY-MM-DDTHH:mm:ss.SSSZ',
        dateLong: 'D MMMM YYYY',
        dateShort: 'DD/MM/YYYY',
        dateDefault: 'DD/MM/YYYY',
        timeShort: 'HH:mm',
        timeLong: 'HH:mm:ss',
        timeDefault: 'HH:mm:ss'
    },
    ianaTimeZoneName: undefined,
    ordinalStringFormatter: get_ordinal_string_for_number_1.getOrdinalStringForNumber
};
//# sourceMappingURL=date.js.map